import { ComponentFactory, ComponentFactoryResolver, NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { GtgtContentComponent } from './gtgt-content.component';

@NgModule({
	declarations: [
		GtgtContentComponent
	],
	imports: [
		CommonModule
	],
	exports: [
		GtgtContentComponent
	]
})
export class GtgtContentModule {
	constructor(private resolver: ComponentFactoryResolver) { }

	public resolveComponentFactory(): ComponentFactory<GtgtContentComponent> {
		return this.resolver.resolveComponentFactory(GtgtContentComponent);
	}
}
